import axios from "axios";
import "../components/Error";
import { getEnv } from "../helpers/Config";

// "homepage": "https://recallrtr-test.azurewebsites.net/CymeTechMurphyBed",
export const Axios = {
  email,
  addressValidation,
};
function email(data, instance) {
  const name = data.firstName + " " + data.lastName;
  const address2 = data.city + "," + data.state + " " + data.postalCode;
  const phone = data.phoneNumber;
  const email = data.email;
  let address = data.address;
  if (data.address2) {
    address = address + "," + data.address2;
  }
  let recipients = [email];
  let BccRecipients = ["figuresandnets@realtimeresults.net"];
  var emailToSend = {
    EmailFrom: "recallrtr@realtimeresults.net",
    Subject: "Cyme Tech Murphy Beds Confirmation of Registration",
    IsHtml: true,
    DisplayName: "no-reply@realtimeresults.net",
    Recipients: recipients,
    BccRecipients: BccRecipients,
    Body:
      "<h2 style='color: black; font-weight: bold;text-align:center;'>Cyme Tech Murphy Beds Recall</h2><br /><h3 style='color: black;text-align:center;'>Thank you for participating in the recall.</h3><br /><h3 style='color: black;text-align:center;'>Your Registration ID is " +
      instance +
      "</h3><table><tr><td><p style='color: black; font-weight: bold;'>Name</p></td><td></td><td><p style='color: black;'>" +
      name +
      "</p></td></tr><tr><td><p style='color: black; font-weight: bold;'>Address</p></td><td></td><td><p style='color: black;'>" +
      address +
      "</p></td></tr><tr><td><p style='color: black; font-weight: bold;'></p></td><td></td><td><p style='color: black;'>" +
      address2 +
      "</p></td></tr><tr><td><p style='color: black; font-weight: bold;'>Email</p></td><td></td><td><p style='color: black;'>" +
      email +
      "</p></td></tr><tr><td><p style='color: black; font-weight: bold;'>Phone</p></td><td></td><td><p style='color: black;'>" +
      phone +
      "</p></td></tr></table><p style='color: black;'>We will review the information provided and contact you if we have questions or if we require additional information.</p><p style='color: black;'>Once we review and confirm your unit is affected, we will send a repair kit to the address you provided and contact you to arrange to send trained technicians to your home at a mutually convenient time.  The technicians will inspect and repair your bed at no cost to you.</p><p style='color: black'>You should immediately stop using the Murphy bed and ensure that the chain lock is fully engaged with the bed until we have completed the inspection and repair of your bed.</p><p style='color: gray;'>If you need assistance, please contact a representative at 1-800-320-7096 between 8:30 a.m. and 6:00 p.m. (Eastern Time) Monday through Friday.</p>",
  };
  let url = getEnv();
  axios({
    method: "post",
    url: url + "/api/StaticData/SendEmail",
    data: emailToSend,
  })
    .then((response) => {
      console.log("success");
      return true;
    })
    .catch((response) => {
      console.log("fail");
      return false;
    });
}
function addressValidation(data) {
  let url = getEnv();
  var person = {
    Name: data.firstName + " " + data.lastName,
    Address: data.address,
    Address2: data.address2,
    City: data.city,
    State: data.state,
    Country: "US",
    PostalCode: data.postalCode,
  };
  axios({
    method: "post",
    url: url + "/Verification/Address",
    data: person,
  })
    .then((response) => {
      console.log("success");
      let responseNumber = Object.keys(response).length;
      var returnResponse = {
        Message: response[0].responseMessage,
        Valid: true,
      };
      if (responseNumber > 1) {
        returnResponse.Valid = false;
        return returnResponse;
      }
      if (returnResponse.Message === "Invalid UPS Shipping Address.") {
        returnResponse.Message =
          "Mailing address is not recognized.  Please verify the information in all fields and correct where needed. If you want to submit the registration with the address as listed, check the box below.";
        returnResponse.Valid = false;
        return returnResponse;
      }
      returnResponse.Address = response[0].address;
      returnResponse.Address = response[0].city;
      returnResponse.Address = response[0].state;
      returnResponse.Address = response[0].postalCode;
    })
    .catch((response) => {
      var returnResponse = {
        Message: response[0].responseMessage,
        Valid: false,
      };
      return returnResponse;
    });
}
